import { Navigate, Link, NavLink } from "react-router-dom";
import { LogOut, LayoutDashboard, Users } from "lucide-react";
import { useAuth } from "../platform/AuthContext";

// Layout protégé : redirige vers /connexion si non authentifié, /espace si commerçant.
export default function AdminLayout({ children, role = "admin" }) {
  const { user, ready, logout } = useAuth();

  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-brume">
        <span className="h-8 w-8 animate-spin rounded-full border-2 border-electric border-t-transparent" aria-label="Chargement" />
      </div>
    );
  }
  if (!user) return <Navigate to="/connexion" replace />;
  if (role === "admin" && user.role !== "admin") return <Navigate to="/espace" replace />;
  if (role === "merchant" && user.role !== "merchant") return <Navigate to="/admin" replace />;

  return (
    <div className="min-h-screen bg-brume">
      <header className="sticky top-0 z-40 border-b border-nuit-900/10 bg-nuit-950/95 backdrop-blur">
        <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-4 sm:px-6">
          <div className="flex items-center gap-6">
            <Link to={user.role === "admin" ? "/admin" : "/espace"}>
              <img src="/assets/logo-white.png" alt="Noveocard" className="h-5 w-auto" width="141" height="20" />
            </Link>
            {user.role === "admin" && (
              <nav className="flex items-center gap-1" aria-label="Administration">
                <NavLink to="/admin" end data-testid="admin-nav-dashboard"
                  className={({ isActive }) => `flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-xs font-semibold transition-colors ${isActive ? "bg-electric text-white" : "text-white/60 hover:text-white"}`}>
                  <LayoutDashboard className="h-3.5 w-3.5" /> Tableau de bord
                </NavLink>
                <NavLink to="/admin/clients" data-testid="admin-nav-clients"
                  className={({ isActive }) => `flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-xs font-semibold transition-colors ${isActive ? "bg-electric text-white" : "text-white/60 hover:text-white"}`}>
                  <Users className="h-3.5 w-3.5" /> Clients
                </NavLink>
              </nav>
            )}
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden text-xs text-white/50 sm:block">{user.email}</span>
            <button onClick={logout} data-testid="logout-btn"
              className="flex items-center gap-1.5 rounded-full border border-white/15 px-3.5 py-1.5 text-xs font-semibold text-white/75 transition-colors hover:border-white/40 hover:text-white">
              <LogOut className="h-3.5 w-3.5" /> Déconnexion
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-8 sm:px-6">{children}</main>
    </div>
  );
}
